import reviewsActionTypes from '../actionTypes/reviewsActionTypes';

const initialState = {
  reviewsList: [],
  userReviewsList: [],
  productReviewsList: [],
  reviewsPagination: {},
  userReviewsListPagination: {},
  productReviewsListPagination: {},
  reviewsIsLoading: false,
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case reviewsActionTypes.GET_REVIEWS_START:
      return {
        ...state,
        reviewsIsLoading: true,
      };
    case reviewsActionTypes.GET_REVIEWS_SUCCESS:
      return {
        ...state,
        reviewsList: payload.data,
        reviewsPagination: payload.meta.pagination,
        reviewsIsLoading: false,
      };
    case reviewsActionTypes.GET_REVIEWS_FAILURE:
      return {
        ...state,
        reviewsIsLoading: false,
      };
    case reviewsActionTypes.GET_USER_REVIEWS_START:
      return {
        ...state,
        reviewsIsLoading: true,
      };
    case reviewsActionTypes.GET_USER_REVIEWS_SUCCESS:
      return {
        ...state,
        userReviewsList: payload.data,
        userReviewsListPagination: payload.meta.pagination,
        reviewsIsLoading: false,
      };
    case reviewsActionTypes.GET_USER_REVIEWS_FAILURE:
      return {
        ...state,
        reviewsIsLoading: false,
      };
    case reviewsActionTypes.GET_PRODUCT_REVIEWS_START:
      return {
        ...state,
        reviewsIsLoading: true,
      };
    case reviewsActionTypes.GET_PRODUCT_REVIEWS_SUCCESS:
      return {
        ...state,
        productReviewsList: payload.data,
        productReviewsListPagination: payload.meta.pagination,
        reviewsIsLoading: false,
      };
    case reviewsActionTypes.GET_PRODUCT_REVIEWS_FAILURE:
      return {
        ...state,
        productIsLoading: false,
      };
    default:
      return state;
  }
};

export default reducer;
